'use client';

import { Icon, tw } from '@repo/ui';

interface SocialLinksProps {
  theme?: 'black' | 'green';
}

export const SocialLinks: React.FC<SocialLinksProps> = ({
  theme = 'black',
}) => {
  const isGreen = theme === 'green';

  return (
    <div className='flex items-center justify-center gap-4'>
      <a
        href='https://www.instagram.com/thedoodles'
        target='_blank'
        rel='noopener'
        className={tw(
          isGreen
            ? 'rounded-full bg-[#05FEA8] p-2 shadow-lg backdrop-blur-md'
            : null,
        )}
      >
        <Icon
          name={isGreen ? 'instagram-black' : 'instagram'}
          folder='core'
          height={24}
          width={24}
          className='h-6 w-6'
        />
      </a>
      <a
        href='https://twitter.com/doodles'
        target='_blank'
        rel='noopener'
        className={tw(
          isGreen
            ? // eslint-disable-next-line max-len
              'flex h-10 w-10 items-center justify-center rounded-full bg-[#05FEA8] shadow-lg backdrop-blur-md'
            : null,
        )}
      >
        <Icon
          name={isGreen ? 'x-black' : 'x'}
          folder='core'
          height={isGreen ? 20 : 22}
          width={isGreen ? 20 : 22}
          className={isGreen ? 'h-5 w-5' : 'h-[22px] w-[22px]'}
        />
      </a>
      <a
        href='https://www.youtube.com/@welikethedoodles'
        target='_blank'
        rel='noopener'
        className={tw(
          isGreen
            ? 'rounded-full bg-[#05FEA8] p-2 shadow-lg backdrop-blur-md'
            : null,
        )}
      >
        <Icon
          name={isGreen ? 'youtube-black' : 'youtube2'}
          folder='core'
          height={24}
          width={24}
          className='h-6 w-6'
        />
      </a>
      <a
        href='https://www.tiktok.com/@doodles'
        target='_blank'
        rel='noopener'
        className={tw(
          isGreen
            ? 'rounded-full bg-[#05FEA8] p-2 shadow-lg backdrop-blur-md'
            : null,
        )}
      >
        <Icon
          name={isGreen ? 'tiktok-black' : 'tiktok'}
          folder='core'
          height={24}
          width={24}
          className='h-6 w-6'
        />
      </a>
      <a
        href='https://discord.gg/doodles'
        target='_blank'
        rel='noopener'
        className={tw(
          isGreen
            ? 'rounded-full bg-[#05FEA8] p-2 shadow-lg backdrop-blur-md'
            : null,
        )}
      >
        <Icon
          name={isGreen ? 'discord-black' : 'discord'}
          folder='core'
          height={24}
          width={24}
          className='h-6 w-6'
        />
      </a>
    </div>
  );
};
